

class ProductBottomDrawer extends HTMLElement {
  constructor() {
    super();

    this.props = {
      product: {},
      selectedVariant: {},
      variants: [],
      options:[],
    };

    this.state = {
      quantity: 1,
      drawerStatus: "idle", // idle | active
      addToCartStatus: "idle", // loading | idle
      product: {},
      selectedVariant: {},
    };

    this.drawerStateEnum = {
      CLOSED: "closed",
      HALF_OPENED: "halfOpened",
      FULLY_OPENED: "fullyOpened",
    };

    this.drawerState = this.drawerStateEnum.HALF_OPENED;
  }

  connectedCallback() {
    this.initState();

    this.render(this.getRenderData());
    this.attachCallback();


  setTimeout(() => {
    this.initEventListeners();
  }, 100);
  
    ProductPageStore.subscribe((event, prevState) => {
      const { currentProduct, currentVariant } = event.detail;
      this.updateState({
        product: currentProduct,
        selectedVariant: currentVariant,
      });
    });

  }

  initState() {
    const { currentProduct, currentVariant } = ProductPageStore.getState();
    this.state.product = currentProduct;
    this.state.options = currentProduct.options;
    this.state.selectedVariant = currentVariant;
  }

  updateState(updates) {
    this.state = { ...this.state, ...updates };
    this.render(this.getRenderData());
    this.initEventListeners();
    this.attachCallback();
  }
  
  attachCallback() {
    const changeSizeBtn = this.querySelector(
      "product-bottom-drawer-change-size-button"
    )
    if(changeSizeBtn) changeSizeBtn.toggleDrawer = this.toggleDrawer.bind(this);
  }

  pollingMainCTA() {
    const interval = setInterval(() => {
      const mainCTA = this.closest("section").querySelector("block-buy-button");
      const isLoading = mainCTA.submitButton.classList.contains("loading");
      if (!isLoading) {
        this.updateState({ addToCartStatus: "idle" });
        clearInterval(interval);
      }
    }, 100);
  }

  initEventListeners() {
    const screenOverlay = document.querySelector(".screen-overlay");

    if (screenOverlay) {
      screenOverlay.addEventListener("click", () => this.toggleDrawer());
    }

    window.addEventListener("scroll", () => this.handleScroll());

    const mainCTA = document.getElementById("add-to-cart-cta");
    const CTAButtons = document.querySelectorAll(".drawer-CTA-add");

    CTAButtons.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        const { isShown, preOrderButton } = this.checkIsPreOrderVariant();
        if (isShown) {
          preOrderButton.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          const buttons = [...mainCTA.querySelectorAll("button")]; // Assuming the form is a parent of mainCTA
          const button = buttons.find(
            (button) => button.getBoundingClientRect().width > 0
          );
          button?.click();
        }

        this.updateState({ addToCartStatus: "loading" });
        this.pollingMainCTA();
      });
    });

    const variantItems = document.querySelectorAll("#variants");
    variantItems.forEach((variantItem) => {
      variantItem.addEventListener("change", (event) => {
        this.handleVariantClick(event);
      });
    });
  }

  getRenderData() {
    const result = {};
    result.isAddingToCart = this.state.addToCartStatus === "loading";
    result.isExpand = this.state.drawerStatus === "active";
    result.title = this.state.product.title;
    result.discountPercentage = this.state.selectedVariant?.compare_at_price
      ? Math.round(
        ((this.state.selectedVariant?.compare_at_price -
          this.state.selectedVariant?.price) *
          100) /
        this.state.selectedVariant?.compare_at_price
      )
      : 0;
    result.price = (this.state.selectedVariant?.price / 100) * this.state.quantity;
    result.compareAtPrice = 
      (this.state.selectedVariant?.compare_at_price / 100) * this.state.quantity;
    result.isDiscounted = result.discountPercentage > 0;
    result.size = this.state.selectedVariant?.title?.split("|")?.[0]?.trim();
    return result;
  }

  checkIsPreOrderVariant() {
    const preOrderButton = this.closest("section").querySelector(
      "[data-native-pre-order-btn]"
    );
    if (!preOrderButton) return { isShown: false, preOrderButton: null };
    const isShown = preOrderButton.getBoundingClientRect().width !== 0;
    return { isShown, preOrderButton };
  }

  handleVariantClick(event) {
     const select = event.target;
  const selectedOption = select.options[select.selectedIndex];
  const clickedVariantId = Number(selectedOption.dataset.variantId);
  const clickedVariant = this.state.product.variants.find(
    (variant) => variant.id === clickedVariantId
  );


  if (clickedVariant) {
    ProductPageStore.setState({ currentVariant: clickedVariant });
  }
  }

   renderSelectionList() {
    const { selectedVariant, product } = this.state;
    console.log(product.variants, "variant")
    if (!product || !selectedVariant || selectedVariant.title == "Default Title" || !product.variants || product.variants.length === 0) {
      return "";
    }

    return `
        <div class="p-3 pt-0 relative" >
          <select id="variants"
            class="bg-[#F9F7F6] w-full px-4 py-2 rounded-lg text-sm h-[48px] border-none"
          >
            ${product.variants.map(
                  (value) => `
                  <option data-variant-id="${value.id}" value="${value.title}" ${value.title === selectedVariant.title ? "selected" : ""
                    }>
                    ${value.title}
                  </option>
                `
                )
                .join("")}
          </select>
        </div>
    `;
  }

  render(data) {
    this.innerHTML = `
    <div id="bottom-drawer-cont" class="w-full sm:hidden">
      <div id="bottom-drawer" class="top-[110px] left-0 z-40 shadow-[0_6px_25px_2px_#00000014] bottom-drawer bg-white  w-full transition-all duration-300 sm:hidden overflow-visible">
        <div class="p-3 flex justify-between items-end gap-2">
  
          <div class="flex flex-col items-start gap-1 grow">
            <div class="flex justify-center items-center text-[#DA1F00] font-semibold text-xs ${!data.isDiscounted ? "hidden" : ""}">
            ${data.discountPercentage}% 할인
            </div>
           
            <div class="flex flex-col gap-1">
              <div class="flex justify-start gap-2">
              <p class="text-sm font-normal line-through ${!data.isDiscounted ? "hidden" : ""}">${data.compareAtPrice.toLocaleString()}원</p>
                <p class="text-sm text-[#DA1F00] font-semibold">${data.price.toLocaleString()}원</p>
              </div>
              <p class="font-normal text-xs text-[#625A55]">VAT 포함</p>
            </div>
          </div>
  
          <div class="flex flex-col items-end gap-1">
            <button class="drawer-CTA-add w-full bg-[#FFA236] hover:bg-[#2E2F3C] flex items-center justify-center rounded-[32px] gap-2 py-2 px-4 my-4 ${data.isAddingToCart ? "cursor-not-allowed opacity-50" : ""
      }" ${data.isAddingToCart ? "disabled" : ""}>
              
              <p class="text-black font-bold text-sm ${data.isAddingToCart ? "hidden" : ""}">
              장바구니 담기
              </p>
              <div class="loading-overlay__spinner w-4 ${data.isAddingToCart ? "" : "hidden"}">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  class="spinner"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle style="stroke: white;" class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </div>
  
        </div>
        ${this.renderSelectionList()}
      </div>
      </div>
      <div class="screen-overlay fixed bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-black bg-fixed opacity-50 z-30 hidden"></div>
    `;
  }


  getDrawerElements() {
    const bottomDrawer = document.getElementById("bottom-drawer");
    const sizesWrapper = document.getElementById("sizesWrapper");
    const miniCTAButton = document.getElementById("miniCTA");
    const screenOverlay = document.querySelector(".screen-overlay");

    return { bottomDrawer, sizesWrapper, miniCTAButton, screenOverlay };
  }

  handleScroll() {
    const mainCTA = document.getElementById("add-to-cart-cta");
    const mainPosition = document.getElementById("bottom-drawer-cont");
    const bottomDrawer = this.querySelector("#bottom-drawer");

    if (!mainCTA || !mainPosition || !bottomDrawer) return;

    const mainCTARect = mainCTA.getBoundingClientRect();
    const mainPositionRect = mainPosition.getBoundingClientRect();

    const isAboveFold = mainCTARect.bottom > 0 && mainCTARect.top < window.innerHeight;
    if (mainPositionRect.top <= 100 && !isAboveFold) {
      bottomDrawer.classList.add("fixed","rounded-bl-lg", "rounded-br-lg");
      bottomDrawer.classList.remove("hidden");
    } else {
      if (!isAboveFold) {
        bottomDrawer.classList.remove("fixed","rounded-bl-lg", "rounded-br-lg", "hidden");
      } else {
        bottomDrawer.classList.add("hidden");
      } 
    }
  }

  disableScrolling() {
    document.documentElement.style.overflow = "hidden";
  }

  enableScrolling() {
    document.documentElement.style.overflow = "";
  }

  toggleDrawer() {
    this.drawerState =
      this.drawerState === this.drawerStateEnum.HALF_OPENED
        ? this.drawerStateEnum.FULLY_OPENED
        : this.drawerStateEnum.HALF_OPENED;

    this.updateDrawer();
  }
}

customElements.define("product-bottom-drawer", ProductBottomDrawer);

class ProductBottomDrawerChangeSizeButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this.initEventListeners();
  }

  disconnectedCallBack() {
    this.removeEventListener();
  }

  initEventListeners() {
    this.querySelector('button[name="size"]').addEventListener(
      "click",
      this.handleClick.bind(this)
    );
  }

  removeEventListener() {
    this.querySelector('button[name="size"]').removeEventListener(
      "click",
      this.handleClick.bind(this)
    );
  }

  handleClick() {
    this.toggleDrawer();
  }

  render() {
    this.innerHTML = `<button name="size" class="text-xs underline">사이즈 변경</button>`;
  }
}

customElements.define(
  "product-bottom-drawer-change-size-button",
  ProductBottomDrawerChangeSizeButton
);
